import ActivityNote from '@Components/General/Activity/Components/ActivityNote';
import ActivityTimeLine from '@Components/General/Activity/Components/ActivityTimeLine';
import AddActivity from '@Components/General/Activity/Components/AddActivity';
import { Card, CardContent, CardHeader } from '@mui/material';
import { useState } from 'react';

const activities = [
    {
        id: '1',
        activity_date: '2024-01-15',
        note: 'Payment received at office',
        user_id: '130cc71a-01c0-4fd7-809c-f5935d141ef4',
        user_picture_url:
            'https://img.propelauth.com/3a62cece-0afa-49ea-a516-751b62309f4a_dedcc5e3-5a33-4471-8edf-53a637faf947.png',
        user_name: 'shmueltrevor@gmail.com',
    },
    {
        id: '2',
        activity_date: '2024-01-16',
        note: 'Receipt issued and emailed',
        user_id: '130cc71a-01c0-4fd7-809c-f5935d141ef4',
        user_picture_url:
            'https://img.propelauth.com/3a62cece-0afa-49ea-a516-751b62309f4a_dedcc5e3-5a33-4471-8edf-53a637faf947.png',
        user_name: 'shmueltrevor@gmail.com',
    },
    {
        id: '3',
        activity_date: '2024-01-20',
        note: 'Check deposited',
        user_id: '130cc71a-01c0-4fd7-809c-f5935d141ef4',
        user_picture_url:
            'https://img.propelauth.com/3a62cece-0afa-49ea-a516-751b62309f4a_dedcc5e3-5a33-4471-8edf-53a637faf947.png',
        user_name: 'shmueltrevor@gmail.com',
    },
    {
        id: '4',
        activity_date: '2024-01-22',
        note: 'Check cleared',
        user_id: '130cc71a-01c0-4fd7-809c-f5935d141ef4',
        user_picture_url:
            'https://img.propelauth.com/3a62cece-0afa-49ea-a516-751b62309f4a_dedcc5e3-5a33-4471-8edf-53a637faf947.png',
        user_name: 'shmueltrevor@gmail.com',
    },
    {
        id: '5',
        activity_date: '2024-02-10',
        note: 'Online transfer received',
        user_id: '130cc71a-01c0-4fd7-809c-f5935d141ef4',
        user_picture_url:
            'https://img.propelauth.com/3a62cece-0afa-49ea-a516-751b62309f4a_dedcc5e3-5a33-4471-8edf-53a637faf947.png',
        user_name: 'shmueltrevor@gmail.com',
    },
    {
        id: '6',
        activity_date: '2024-02-11',
        note: 'Payment recorded in ledger',
        user_id: '130cc71a-01c0-4fd7-809c-f5935d141ef4',
        user_picture_url:
            'https://img.propelauth.com/3a62cece-0afa-49ea-a516-751b62309f4a_dedcc5e3-5a33-4471-8edf-53a637faf947.png',
        user_name: 'shmueltrevor@gmail.com',
    },
    {
        id: '7',
        activity_date: '2024-12-05',
        note: 'Payment processed',
        user_id: '130cc71a-01c0-4fd7-809c-f5935d141ef4',
        user_picture_url:
            'https://img.propelauth.com/3a62cece-0afa-49ea-a516-751b62309f4a_dedcc5e3-5a33-4471-8edf-53a637faf947.png',
        user_name: 'shmueltrevor@gmail.com',
    },
    {
        id: '8',
        activity_date: '2024-12-06',
        note: 'Email confirmation sent',
        user_id: '130cc71a-01c0-4fd7-809c-f5935d141ef4',
        user_picture_url:
            'https://img.propelauth.com/3a62cece-0afa-49ea-a516-751b62309f4a_dedcc5e3-5a33-4471-8edf-53a637faf947.png',
        user_name: 'shmueltrevor@gmail.com',
    },
];

const DonationActivity = ({}) => {
    const [editActivity, setEditActivity] = useState(null);

    return (
        <Card
            elevation={0}
            sx={{
                mx: 0,
            }}
        >
            <CardHeader title="Activity" />
            <CardContent
                sx={{
                    pt: 0,
                    '&: last-child': {
                        pb: 0,
                    },
                }}
            >
                <ActivityTimeLine>
                    <AddActivity onSubmit={() => {}} />
                    {activities.map(activity => (
                        <ActivityNote
                            key={activity.id}
                            activity={activity}
                            onEdit={() => {}}
                            onDelete={() => {}}
                            onCancel={() => {}}
                            onUpdate={() => {}}
                            isEditing={editActivity === activity.id}
                        />
                    ))}
                    {/* <ActionActivity /> */}
                </ActivityTimeLine>
            </CardContent>
        </Card>
    );
};

export default DonationActivity;
